import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Address, Email, Location } from "../constant/Index";
import { useForm } from "../Hooks/Form";
import { useContactContentMutation } from "../store/services/NewsletterService";
import { useSiteContentQuery } from "../store/services/SitesettingService";

const ContactForm = () => {
	const { data, isLoading } = useSiteContentQuery();
	let Siteresponse = data?.response?.data[0];

	const [errors, setErrors] = useState([]);
	const { state, onChange } = useForm({
		name: "",
		email: "",
		phone_number: "",
		subject: "",
		message: "",
	});
	let { name, email, phone_number, subject, message } = state;
	const [userContact, response] = useContactContentMutation();

	const onSubmit = (e) => {
		e.preventDefault();
		const FormDatas = new FormData();
		FormDatas.append("name", name);
		FormDatas.append("email", email);
		FormDatas.append("phone_number", phone_number);
		FormDatas.append("subject", subject);
		FormDatas.append("message", message);
		userContact(FormDatas);
	};

	useEffect(() => {
		if (response.isError) {
			setErrors(response?.error?.data?.errors);
		}
	}, [response?.error?.data]);

	useEffect(() => {
		if (response.isSuccess) {
			toast.success(response?.data?.message);
			setErrors([]);
			state.name = "";
			state.email = "";
			state.phone_number = "";
			state.subject = "";
			state.message = "";
		}
	}, [response.isSuccess]);
	return (
		<>
			<section className="contact_sec">
				<div className="glowing glowing-left">
					<span></span>
				</div>
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<div className="contact-info-box">
								<div className="heading-wrapper">
									<h4>CONTACT US</h4>
									<h3>CONTACT INFO</h3>
									<p>
										Lorem ipsum dolor sit amet, consectetur adipiscing elit,
									</p>
								</div>
								<ul className="info">
									<li>
										<div className="icon-box">
											<figure>
												<img src={Email} alt="" className="img-fluid" />
											</figure>
										</div>
										<div className="txt">
											<h3>EMAIL ADDRESS</h3>
											<a href={"mailto:" + Siteresponse?.contact_email}>
												{Siteresponse?.contact_email}
											</a>
										</div>
									</li>
									<li>
										<div className="icon-box">
											<figure>
												<img src={Location} alt="" className="img-fluid" />
											</figure>
										</div>
										<div className="txt">
											<h3>LOCATION</h3>
											<a href="#">{Siteresponse?.address}</a>
										</div>
									</li>
									<li>
										<div className="icon-box">
											<figure>
												<img src={Address} alt="" className="img-fluid" />
											</figure>
										</div>
										<div className="txt">
											<h3>PHONE NUMBER</h3>
											<a href={"tel:" + Siteresponse?.contact_phone}>
												{Siteresponse?.contact_phone}
											</a>
										</div>
									</li>
								</ul>
							</div>
						</div>
						<div className="col-lg-8">
							<div className="contact-form-box">
								<div className="glowing glowing-one">
									<span></span>
								</div>
								<div className="heading-wrapper">
									<h4>CONTACT US</h4>
									<h2>FEEL FREE TO MESSAGE</h2>
									<p>
										Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
										do eiusmod
									</p>
									<div className="glowing">
										<span></span>
									</div>
								</div>
								<form onSubmit={onSubmit}>
									<div className="row">
										<div className="col-md-6">
											<div className="form-group">
												<label>Your Name</label>
												{/* <input
													type="text"
													placeholder="Enter your name *"
													className="form-control"
												/> */}
												<input
													type="text"
													className={`${errors && errors?.name
														? "SetErrorshow form-control"
														: "form-control"
														}`}
													id="inputname"
													placeholder="Enter your name *"
													name="name"
													value={name}
													onChange={onChange}
												/>
												{errors && errors?.name && (
													<span className="errorMessage">
														<p>{errors && errors?.name}</p>
													</span>
												)}
											</div>
										</div>
										<div className="col-md-6">
											<div className="form-group">
												<label>Your Email</label>
												{/* <input
													type="email"
													placeholder="Enter your email *"
													className="form-control"
												/> */}
												<input
													type="email"
													className={`${errors && errors?.email
														? "SetErrorshow form-control"
														: "form-control"
														}`}
													id="inputname"
													placeholder="Enter your email *"
													name="email"
													value={email}
													onChange={onChange}
												/>
												{errors && errors?.email && (
													<span className="errorMessage">
														<p>{errors && errors?.email}</p>
													</span>
												)}
											</div>
										</div>
										<div className="col-md-6">
											<div className="form-group">
												<label>Your Phone Number </label>
												{/* <input
													type="tel"
													placeholder="Enter Phone *"
													className="form-control"
												/> */}
												<input
													type="tel"
													className={`${errors && errors?.phone_number
														? "SetErrorshow form-control"
														: "form-control"
														}`}
													id="inputname"
													placeholder="Enter Phone *"
													name="phone_number"
													value={phone_number}
													onChange={onChange}
												/>
												{errors && errors?.phone_number && (
													<span className="errorMessage">
														<p>{errors && errors?.phone_number}</p>
													</span>
												)}
											</div>
										</div>
										<div className="col-md-6">
											<div className="form-group">
												<label>Subject</label>
												{/* <input
													type="text"
													placeholder="Enter Subject*"
													className="form-control"
												/> */}
												<input
													type="tel"
													className={`${errors && errors?.subject
														? "SetErrorshow form-control"
														: "form-control"
														}`}
													id="inputname"
													placeholder="Enter Subject*"
													name="subject"
													value={subject}
													onChange={onChange}
												/>
												{errors && errors?.subject && (
													<span className="errorMessage">
														<p>{errors && errors?.subject}</p>
													</span>
												)}
											</div>
										</div>
										<div className="col-md-12">
											<div className="form-group">
												<label>Message Here</label>
												<textarea
													className={`${errors && errors?.message
														? "SetErrorshow form-control"
														: "form-control"
														}`}
													id="inputname"
													placeholder="Enter your Message *"
													name="message"
													value={message}
													onChange={onChange}
												></textarea>
												{errors && errors?.message && (
													<span className="errorMessage">
														<p>{errors && errors?.message}</p>
													</span>
												)}
											</div>
										</div>
										<div className="col-md-12">
											<div className="button-group">
												<button className="buy-btn blue" type="submit">
													<span className="txt">SUBMIT</span>
													<span className="svg-icon">
														<svg width="28" height="28" viewBox="0 0 28 28">
															<defs>
																<filter
																	id="Ellipse_15"
																	x="0"
																	y="0"
																	width="28"
																	height="28"
																	filterUnits="userSpaceOnUse"
																>
																	<feOffset dy="2" input="SourceAlpha" />
																	<feGaussianBlur
																		stdDeviation="1"
																		result="blur"
																	/>
																	<feFlood floodOpacity="0.302" />
																	<feComposite operator="in" in2="blur" />
																	<feComposite in="SourceGraphic" />
																</filter>
															</defs>
															<g
																id="Group_27"
																data-name="Group 27"
																transform="translate(-340 -668)"
															>
																<g
																	transform="matrix(1, 0, 0, 1, 340, 668)"
																	filter="url(#Ellipse_15)"
																>
																	<circle
																		id="Ellipse_15-2"
																		data-name="Ellipse 15"
																		cx="11"
																		cy="11"
																		r="11"
																		transform="translate(3 1)"
																		fill="#f9f928"
																	/>
																</g>
																<path
																	id="Path_16"
																	data-name="Path 16"
																	d="M585.823,402.516a.646.646,0,0,1-.556-.634c0-.054,0-.107,0-.161q0-3.333,0-6.665a1.178,1.178,0,0,1,.069-.419.626.626,0,0,1,.806-.343,2.325,2.325,0,0,1,.541.217q2.694,1.538,5.38,3.087a1.207,1.207,0,0,1,.509.48.736.736,0,0,1-.262.933,2.108,2.108,0,0,1-.255.17l-5.37,3.085a1.994,1.994,0,0,1-.669.249Z"
																	transform="translate(-233.954 281.611)"
																	fill="#d13900"
																/>
															</g>
														</svg>
													</span>
												</button>
											</div>
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default ContactForm;
